import {ProductRecommendationsDefinition} from './ProductRecommendations'

export {ProductRecommendationsDefinition}
